import {mutateElement} from "./mutateElement";
import {generateUUID2, isDarkMode} from "../../../../src/utils";
import {getCardlinkCacheById, updatecardlinkCache} from "../../../../model";
import CryptoJS from 'crypto-js';

function createElement(name: string, className?: string): any {
  const dom = document.createElement(name);
  if (className) {
    dom.className = className;
  }
  return dom;
}

function createSVG(name: string) {
  return document.createElementNS("http://www.w3.org/2000/svg", name);
}
/**
 * Set element attribute
 * @param {HTMLElement} el Element
 * @param {Object} obj Objects of key-value pairs
 */

function setAttribute(el: any, obj: any) {
  for (const key in obj) {
    el.setAttribute(key, obj[key]);
  }
}

function appendChild(el: any, child: Node) {
  el.appendChild(child);
}

function isHttp(url: string): boolean {
  return /^(https?:)?\/\//g.test(url);
}

function createIcon(icon: string, _parse: any) {
  const svg = createSVG("svg")!;
  svg.classList.add("card-link-icon");
  svg.style.background = "#ebebeb";
  setAttribute(svg, {
    fill: "#d4d4d4",
    viewBox: "0 0 1024 1024",
  });
  const path = createSVG("path");
  setAttribute(path, {
    // eslint-disable-next-line max-len
    d: "M177.152 384a357.546667 357.546667 0 0 0-23.552 128 357.546667 357.546667 0 0 0 23.552 128h140.245333a791.808 791.808 0 0 1-10.197333-128c0-44.714667 3.584-87.722667 10.197333-128H177.152z m24.405333-51.2h126.250667c15.786667-65.024 40.021333-120.405333 69.76-160.554667A359.466667 359.466667 0 0 0 201.557333 332.8zM844.8 378.709333V384h-138.197333c6.613333 40.277333 10.197333 83.285333 10.197333 128s-3.584 87.722667-10.197333 128H844.8v5.290667c16.512-41.216 25.6-86.186667 25.6-133.290667a357.418667 357.418667 0 0 0-25.6-133.290667zM822.442667 332.8a359.466667 359.466667 0 0 0-196.010667-160.554667c29.738667 40.149333 53.930667 95.573333 69.76 160.554667h126.293333zM369.365333 384a736.042667 736.042667 0 0 0-10.965333 128c0 45.354667 3.968 88.448 10.965333 128h285.269334c6.997333-39.552 10.965333-82.645333 10.965333-128s-3.968-88.448-10.965333-128H369.365333z m11.264-51.2h262.741334c-28.586667-108.032-80.725333-179.2-131.370667-179.2-50.645333 0-102.741333 71.168-131.370667 179.2z m-179.072 358.4a359.466667 359.466667 0 0 0 196.010667 160.554667c-29.738667-40.149333-53.930667-95.573333-69.76-160.554667h-126.293333z m620.885334 0h-126.250667c-15.786667 65.024-40.021333 120.405333-69.76 160.554667a359.466667 359.466667 0 0 0 196.010667-160.554667z m-441.813334 0c28.586667 108.032 80.725333 179.2 131.370667 179.2 50.645333 0 102.741333-71.168 131.370667-179.2H380.629333zM512 921.6a409.6 409.6 0 1 1 0-819.2 409.6 409.6 0 0 1 0 819.2z",
  });
  appendChild(svg, path);

  if (icon) {
    let i = 1;
    const img = createElement("img", "");
    img.className = "card-link-icon";
    // img.style.height = "20px";
    // img.style.verticalAlign = "bottom";
    // img.style.marginRight = "5px";
    img.src = icon; // If icon is valid, replace `svgIcon` with `imgIcon`

    img.onload = function () {
      img.onload = null;
      svg!.parentNode?.replaceChild(img, svg);
    };
    img.onerror = function () {
      i === 1 && (img.src = _parse.doc.querySelector("body img")?.src || "");
      i++;
    };
  }

  return svg;
}
/**
 * Creating a Document Object Model
 * @param {String} title Website title
 * @param {String} link Website address
 * @param {String} icon Website icon
 * @returns {HTMLElement}
 */
// eslint-disable-next-line max-statements

function createDOM(
  title: string, // 大标题
  link: string,
  icon: string, //
  description: string, //副标题
  image: string, // 左侧大图
  _parse: any,
  element:any
): HTMLElement {
  const wrapDOM = createElement("div", "card-link");
  wrapDOM.style.minHeight = '132px';
  wrapDOM.style.height = (element.customData?.generationData?.originHeight || element.height) + 'px';

  // aDOM
  const aDOM = createElement("div", "card-link-content");
  aDOM.href = link;
  if (element){
    aDOM.style.background = element.backgroundColor;
  }

  aDOM.id = 'embedable-card-link-'+element.id;//修改背景色的时候要换这个颜色

  // left
  // 创建一个新的 <img> 元素
  const imgDom = document.createElement("img");
  imgDom.src = image;
  imgDom.className = "card-link-img";
  // imgDom.style.height = "100%";
  // imgDom.style.width = "30%";
  // imgDom.style.objectFit = "fill";
  // imgDom.style.marginRight = "8px";

  // right
  const textDOM = createElement("div", "card-link-text");
  // icon
  const iconDOM = createIcon(icon, _parse);

  // URL
  const linkDOM = createElement("span", "card-link-url");
  // title
  const titleDOM = createElement("div", "card-link-title");
  titleDOM.id = 'div-card-link-title-'+element.id;
  titleDOM.textContent = title || "";
  const span2 = document.createElement("span");
  span2.className = "card-link-url-text";
  span2.textContent = link;

  // description
  const descriptionDOM = createElement("div", "card-link-description");
  // descriptionDOM.style.fontSize = "12px";

  descriptionDOM.textContent = description;

  appendChild(linkDOM, iconDOM);
  appendChild(linkDOM, span2);

  appendChild(textDOM, linkDOM);
  appendChild(textDOM, titleDOM);
  appendChild(textDOM, descriptionDOM);

  image && appendChild(aDOM, imgDom);
  appendChild(aDOM, textDOM);
  appendChild(wrapDOM, aDOM);
  return wrapDOM;
}

function renderer(
  el: HTMLAnchorElement,
  title: string,
  link: string,
  icon: string,
  description: string,
  image: string,
  _parse: any,
  element:any,
  cache:any
) {
  const id = element.customData?.generationData?.id;
  let customData = {
    generationData:{
      ...element.customData?.generationData || {},
      ...cache,
      id:id || cache.id
    }
  };
  mutateElement(element,{customData:customData});

  title = element?.name || title;
  const dom = createDOM(title, link, icon, description, image, _parse,element)!;

  Array.from(el.attributes).forEach((attr) => {
    dom.querySelector("a")?.setAttribute(attr.name, attr.value);
  });
  el.parentNode?.replaceChild(dom, el);

  //这里才显示notes..
  const nHtml = document.getElementById(`div-input-note-${element.id}`);
  if (nHtml){
    nHtml.style.opacity = '1';
  }
}

function isAbsoluteUrl(url: string) {
  return /^(?:[a-z]+:)?\/\//i.test(url);
}
/**
 * 解析HTML字符串以获取页面的标题、链接和图标
 *
 * @param html - 代表HTML内容的字符串
 * @param link - 页面的URL链接，用于处理相对路径的图标链接
 * @returns 返回一个包含标题、链接和图标的对象
 */
function parse(
  html: string,
  link: string,
): {
  title: string;
  link: string;
  icon: string;
  description: string;
  image: string;
} {
  // 初始化结果对象，包含标题、链接和图标，初始值为空字符串
  const result: any = {
    title: "",
    link,
    icon: "",
    description: "",
    image: "",
  };

  try {
    // 使用DOMParser解析HTML字符串
    const doc = new DOMParser().parseFromString(html, "text/html");

    // 尝试从文档中获取title元素

    // 如果找到title元素，获取其文本内容
    result.title =
      doc.querySelector('meta[property="og:title"]')?.getAttribute("content") ||
      doc.querySelector('meta[name="og:title"]')?.getAttribute("content") ||
      doc.querySelector('meta[name="title"]')?.getAttribute("content") ||
      "";
    result.description =
      doc.querySelector('meta[name="description"]')?.getAttribute("content") ||
      doc
        .querySelector('meta[property="og:description"]')
        ?.getAttribute("content") ||
      "";

    result.image =
      doc.querySelector('meta[property="og:image"]')?.getAttribute("content") ||
      doc.querySelector('meta[name="og:image"]')?.getAttribute("content") ||
      "";

    if (result.image) {
      if (result.image.startsWith("//")) {
        result.image = `https:${result.image}`;
      }
    }

    result.icon =
      doc.querySelector("link[rel='shortcut icon']")?.getAttribute("href") ||
      doc.querySelector("link[rel='icon']")?.getAttribute("href") ||
      "";

    if (result.icon) {
      if (!isAbsoluteUrl(result.icon)) {
        result.icon = new URL(link).origin + result.icon;
      } else {
        if (!result.icon.startsWith('http')){
          result.icon = `https:${result.icon}`;
        }
      }
    }else{
      if (link.startsWith('https://news.163.') || link.startsWith('https://www.163.')){
        result.icon = "https://www.163.com/favicon.ico";
      }
    }
    // console.log(result);
    result.doc = doc;
    // window.doc = doc;
    // if (result.icon && !isHttp(result.icon)) {
    //   result.icon = new URL(link).origin + result.icon;
    // }
  } catch (error) {
    // 捕获解析过程中的错误并打印
    console.error("CardLink Error: Failed to parse", error);
  }

  // 返回包含标题、链接和图标的对象
  return result;
}

const caches: any = {};

function fetchPage(link: string, callback: any) {
  fetch(link)
    .then((result) => {
      return result.text();
    })
    .then(callback)
    .catch(() => {});
}

function cardLink(nodes: any[],element:any) {

  nodes.forEach(async (el) => {
    if (el?.nodeType !== 1) {
      return;
    }
    el.removeAttribute("cardlink");
    const href = el.href;
    const md5 = CryptoJS.MD5(href).toString();
    const cache = await getCardlinkCacheById(md5);//caches[href];
    if (cache) {
      return renderer(
        el,
        cache.title,
        cache.link,
        cache.icon,
        cache.description,
        cache.image,
        cache,
          element,
          cache,
      );
    }

    if (isHttp(href)) {
      fetchPage(href, (html: string) => {
        const _parse = parse(html, href);
        const title = _parse.title;
        const link = _parse.link;
        const icon = _parse.icon;
        const description = _parse.description;
        const image = _parse.image;
        caches[link] = {
          id:CryptoJS.MD5(link).toString(),
          title,
          link,
          icon,
          description,
          image,
        };
        updatecardlinkCache(caches[link])
        renderer(el, title, link, icon, description, image, _parse,element,caches[link]);
      });
    }
  });
}

/**
 * 解析weblink
 * @param href
 */
export function fetchWeblink(href){
  return new Promise(resolve => {
    if (isHttp(href)) {
      fetchPage(href, (html: string) => {
        const _parse = parse(html, href);
        const title = _parse.title;
        const link = _parse.link;
        const icon = _parse.icon;
        const description = _parse.description;
        const image = _parse.image;
        caches[link] = {
          id:link,
          title,
          link,
          icon,
          description,
          image,
        };
        updatecardlinkCache(caches[link]);
        resolve(caches[link]);
      });
    }
  })

}

export { cardLink as default };
